function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export default function NoiceBrand(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 305 68",
        fill: "currentColor"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M145.149 65.566L159.78 1.58775H182.202L167.567 65.566H145.149Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M79.4741 1.58149L64.8437 65.56H46.1588L29.6275 35.2345L29.6215 35.2285L22.6842 65.56H0.267609L14.9046 1.58149H34.8242L50.1559 31.5907L57.0125 1.58149H79.4741Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M119.005 0.681244C100.487 0.681244 82.002 15.5915 77.8062 33.9085C73.6235 52.2252 85.2778 67.1417 103.796 67.1417C128.127 67.1417 142.051 52.2315 146.244 33.9085C150.437 15.5915 137.516 0.681244 119 0.681244H119.005ZM123.975 33.9085C122.419 40.7705 115.495 46.3427 108.563 46.3427C101.631 46.3427 97.2657 40.7705 98.8345 33.9085C100.401 27.0465 107.328 21.474 114.244 21.474C121.163 21.474 125.544 27.0465 123.975 33.9085Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M242.423 14.7337C241.939 16.9055 240.727 18.7365 239.072 20.0262C237.404 21.316 235.301 22.058 233.021 22.058H216.152C215.813 22.058 215.487 22.058 215.148 22.0702C208.956 22.3927 202.897 27.4297 201.503 33.5677C200.044 39.9187 204.078 45.0775 210.499 45.0775H232.966L228.291 65.566H205.813C192.825 65.566 183.333 57.9497 180.709 46.9755C179.732 42.8935 179.701 38.3552 180.795 33.5677C184.829 15.9322 202.626 1.58149 220.457 1.58149H231.582C238.488 1.58149 243.93 8.16974 242.423 14.7277V14.7337Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M228.296 65.566H205.819C192.83 65.566 183.341 57.9497 180.714 46.9752C179.529 29.2545 195.525 22.2952 215.153 22.0702C208.961 22.3925 202.905 27.4295 201.508 33.5677C200.051 39.9187 204.086 45.0772 210.504 45.0772H232.971L228.296 65.566Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M305 1.58149V1.58775L300.971 19.1745H269.576L268.069 25.7507H292.676L289.085 41.47H264.478L262.964 48.046H294.372L290.357 65.5965L236.531 65.5905L251.169 1.58149H305Z",
                fill: "currentColor"
            })
        ]
    }));
}
